module.exports = __webpack_public_path__ + "img/3.b143d264.jpeg";